// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { Apartamento } from "../interfaces/Apartamento";
import { apartamentoByEmpreendimentoService } from "../services/apartamentoByEmpreendimentoService";

export const useApartamentoById = (apartamentoId?: number) => {
  const { isLoading, data, error } = useFetch<Apartamento[]>(
    !!apartamentoId, // só busca se tiver apartamentoId
    apartamentoByEmpreendimentoService,
    [apartamentoId],
    apartamentoId
  );

  return { isLoading, data, error };
};
